function show_appointment_evaluation_qr(appointmentId) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: `/evaluations/appointment-qr/${appointmentId}`,
        onOpen: function (elm, popup) {
        }
    });
    return false;
}

jQuery(document).ready(function($) {
    if (!window.location.pathname.startsWith('/evaluations/student')) {
        return;
    }
    new EvaluationStudentLookup().init();
});

class EvaluationStudentLookup {
    constructor() {
        const hash = window.location.href.split('/').reverse()[0];
        this.api = new StandaloneAPI(`/api/evaluations/student/${hash}`);
    }

    init() {
        jQuery('body').addClass('evaluations-student-lookup');

        this.wrapper = jQuery('.student-lookup-screens');
        this.wrapper.show();
        this.settings = JSON.parse(this.wrapper.attr('data-settings'));

        this.watchInvalidInputs();

        this.wrapper.find('#birthday').dateOnlyInput();

        this.primaryButton = this.wrapper.find('.student-lookup-buttons-wrapper').find('button.primary');
        this.secondaryButton = this.wrapper.find('.student-lookup-buttons-wrapper').find('button.secondary');

        this.loadInitScreen();
    }

    loadInitScreen() {
        const screen = this.activateScreen('initial');

        this.lastName = null;
        this.confirmedNotToBeStudentId = null;


        this.primaryButton.unbind('click').click(async () => {
            const studentsWithThisBirthDay = await this.findTodaysStudentBy('birthday', screen.find('#birthday').val());
            this.foundStudents = studentsWithThisBirthDay;
            if (studentsWithThisBirthDay.length === 1) {
                this.loadStudentFoundScreen(studentsWithThisBirthDay[0]);
            } else {
                this.loadLastnameConfirmationScreen();
            }
        });
    }

    /**
     * Screen for entering the last name
     */
    loadLastnameConfirmationScreen() {
        const screen = this.activateScreen('lastname-confirmation');

        this.primaryButton.unbind('click').click(async () => {
            this.lastName = screen.find('#lastname').val();
            const studentsWithThisLastName = (await this.findTodaysStudentBy('last_name', this.lastName, this.foundStudents.map((student) => student.id)))
                .filter((student) => {
                    return student.id !== this.confirmedNotToBeStudentId;
                });
            this.foundStudents = _.uniqBy([...studentsWithThisLastName, ...this.foundStudents], 'id');
            if (studentsWithThisLastName.length === 1) {
                this.loadStudentFoundScreen(studentsWithThisLastName[0]);
            } else if (studentsWithThisLastName.length > 1) {
                this.loadMultipleStudentsFoundScreen();
            } else {
                this.loadNoStudentFoundScreen();
            }
        });
    }

    /**
     * Screen that shows multiple people with the same birthday and/or last name, let the user select one
     */
    loadMultipleStudentsFoundScreen() {
        const students = this.foundStudents;
        const screen = this.activateScreen('multiple-students-found');

        const submitButton = this.primaryButton;
        submitButton.unbind('click').click(() => {
            const selectedId = screen.find('input:checked').val();
            const selectedStudent = students.find((student) => {
                return student.id === parseInt(selectedId);
            });
            this.confirmStudent(selectedStudent);
        })
        submitButton.attr('disabled', 'disabled');

        this.secondaryButton.unbind('click').click(() => {
            this.loadInitScreen();
        });

        const inputWrapper = screen.find('.input-wrapper');
        inputWrapper.children(':not(:nth-child(1))').remove();
        students.map((student, index) => {
            let row = inputWrapper.find('.student-row:first');
            if (index > 0) {
                row = row.clone();
                inputWrapper.append(row);
            }
            this.fillStudentRow(row, student, false, false);

            row.find('input').unbind('change').change(function() {
                submitButton.removeAttr('disabled');
            });
        });
    }

    /**
     * Screen that shows the student that was found
     */
    loadStudentFoundScreen(student) {
        const screen = this.activateScreen('student-found');

        const row = screen.find('.student-row');
        this.fillStudentRow(row, student, true);

        this.primaryButton.unbind('click').click(() => {
            this.confirmStudent(student);
        });

        this.secondaryButton.unbind('click').click(async () => {
            this.confirmedNotToBeStudentId = student.id;

            if (this.foundStudents.length > 1 && this.lastName) {
                // If user says he's not this person, and you found other students, refetch without birthday combination
                const studentsWithThisLastName = await this.findTodaysStudentBy('last_name', this.lastName);
                this.foundStudents = _.uniqBy([...studentsWithThisLastName, ...this.foundStudents], 'id').filter((foundStudent) => {
                    return foundStudent.id !== student.id;
                });
                this.loadMultipleStudentsFoundScreen();
            } else if (this.lastName) {
                this.loadNoStudentFoundScreen();
            } else {
                this.loadLastnameConfirmationScreen();
            }
            return false;
        });
    }

    /**
     * Show the welcome message and redirect to the evaluation
     *
     * @param student
     * @returns {Promise<void>}
     */
    async confirmStudent(student) {
        const [welcomeHTMLText, url] = await this.get(`welcomeText/${student.id}`);

        const screen = this.activateScreen('welcome-page');
        screen.find('.welcome-text-wrapper').html(welcomeHTMLText);

        window.location.href = url;
    }


    /**
     * Screen that shows no student was found
     */
    loadNoStudentFoundScreen() {
        this.activateScreen('no-student-found');

        this.primaryButton.unbind('click').click(() => {
            this.loadInitScreen();
        });
    }

    fillStudentRow(row, student, checked = false) {
        row.find('.student-name').text(student.messageName);
        row.find('tr.company-info').toggle(!!student.company);
        if (student.company) {
            row.find('.student-company-name').text(student.company.name);
        }

        const input = row.find('input');
        input.removeAttr('checked');
        input.val(student.id);
        input.removeAttr('disabled');
        input.attr('id', `student-${student.id}`);
        if (checked) {
            input[0].checked = true;
        }
        const label = row.find('label');
        label.attr('for', `student-${student.id}`);
    }

    watchInvalidInputs() {
        // use a mutationObserver to check if inputs have the invalid class. Disable the submit button in the same .presence-screen as the input if so
        if (this.observer) {
            this.observer.disconnect();
        }
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const input = mutation.target;
                    if (input.tagName !== 'INPUT') {
                        return;
                    }
                    const screen = jQuery(input.closest('.presence-screen'));
                    const submitButton = screen.find('.confirm-button');
                    if (input.classList.contains('invalid') || input.classList.contains('incomplete')) {
                        submitButton.attr('disabled', 'disabled');
                    } else {
                        submitButton.removeAttr('disabled');
                    }
                }
            });
        });
        this.observer.observe(this.wrapper[0], {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
        });

        this.wrapper.find('form :input[required]').unbind('keyup.validation').bind('keyup.validation', function() {
            const filled = jQuery(this).val().trim().length > 0;
            jQuery(this).removeClass('incomplete');
            jQuery(this).toggleClass('invalid', !filled);
        }).addClass('incomplete');
    }

    activateScreen(screenId) {
        const screensWrapper = this.wrapper.children('.student-lookup-screens-wrapper');
        screensWrapper.children().removeClass('active');
        const screen = screensWrapper.children(`#${screenId}`);
        screen.addClass('active');

        const buttonsWrapper = this.wrapper.find('.student-lookup-buttons-wrapper');
        buttonsWrapper.children().unbind('click');

        // Apply the buttons
        ['primary', 'secondary'].map((buttonType) => {
            const button = buttonsWrapper.find(`button.${buttonType}`);
            const buttonString = screen.attr(`data-${buttonType}-button`);
            button.toggleClass('shown', !!buttonString);
            if (buttonString) {
                button.text(buttonString);
            }

        })

        if (screen.prop('tagName') === 'FORM') {
            screen.unbind('submit').submit(() => {
                // blur activeElement
                document.activeElement.blur();
                return false;
            });
            const inputs = screen.find('input[type="text"]');
            inputs.val('');
            inputs.removeClass('invalid');
            inputs.addClass('incomplete');
            inputs.unbind('focus').bind('focus', function() {
                // Scroll up document
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }

        return screen;
    }

    /**
     * @param field ('birthday' | 'last_name')
     * @param value
     * @param possibleIds
     * @returns {Promise<[]>}
     */
    async findTodaysStudentBy(field, value, possibleIds = []) {
        return await this.get(`findStudentBy/${field}/${value}?possibleIds=${possibleIds.join(',')}`);
    }


    get(path) {
        return this.api.publicGet(path);
    }
    post(path, data) {
        return this.api.publicPost(path, data);
    }
}


